import * as actionType from './actionTypes';

export function setEvents(events:[]) {
  return {
    type: actionType.SET_EVENTS,
    payload: events,
  }
}

export function appendEvents(events:[]) {
  return {
    type: actionType.APPEND_EVENTS,
    payload: events,
  }
}

export function setNoMoreEvent(noMoreEvent: boolean) {
  return {
    type: actionType.SET_NO_MORE_EVENT,
    payload: noMoreEvent,
  }
}

export function setEventFilters(eventFilters:{}) {
  return {
    type: actionType.SET_EVENT_FILTERS,
    payload: eventFilters,
  }
}

export function setEventNotifications(events:{}[]) {
  return {
    type: actionType.SET_EVENT_NOTIFICATIONS,
    payload: events,
  }
}

export function setEventState(state:string) {
  return {
    type: actionType.SET_EVENT_STATE,
    payload: state,
  }
}

export function setNotificationAsRead(event:{}) {
  return {
    type: actionType.SET_NOTIFICATION_AS_READ,
    payload: event,
  }
}

export function setReadEventNotifications(events:{}[]) {
  return {
    type: actionType.SET_READ_EVENT_NOTIFICATIONS,
    payload: events,
  }
}
